/* Mi Socks product page helpers (vanilla, no dependencies).
   1. "Find my size" opens the native <dialog>; the link falls back to #ms-size-guide.
   2. Starts on the "Most popular" pack when the URL names no variant (uses Dawn's own change flow).
   3. Shows the price on the Add to cart button.
   4. Mobile sticky add-to-cart bar that appears once the main button scrolls away.
   5. No size is preselected: until one is picked the button reads "Choose a size" and
      Add to cart / Buy it now / the sticky bar ask for a size instead of adding.
   6. Length / pairs links (ms-pdp-family) keep the chosen size (and color when it exists).
   7. The free-shipping line under the price follows the selected variant. */
(function () {
  if (window.msPdp) return;
  window.msPdp = true;

  var d = document;
  var mainInfo = function () {
    return d.querySelector('product-info[id^="MainProduct-"]');
  };

  // 1. Dialogs (delegated so it survives Dawn re-rendering the variant picker)
  d.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest && t.closest('[data-ms-dialog-open]');
    if (open) {
      var dlg = d.getElementById(open.getAttribute('data-ms-dialog-open'));
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        dlg.showModal();
        dlg._msOpener = open;
      }
      return;
    }
    var close = t.closest && t.closest('[data-ms-dialog-close]');
    if (close) {
      var c = close.closest('dialog');
      if (c) c.close();
      return;
    }
    if (t.tagName === 'DIALOG' && t.classList.contains('ms-dialog')) t.close(); // backdrop
  });
  d.addEventListener(
    'close',
    function (e) {
      var o = e.target && e.target._msOpener;
      if (o && o.isConnected) o.focus();
    },
    true
  );

  var info = mainInfo();
  if (!info) return;
  var sec = info.dataset.section;
  var $ = function (s) {
    return info.querySelector(s);
  };
  var atc = function () {
    return d.getElementById('ProductSubmitButton-' + sec);
  };
  var variantJson = function () {
    try {
      return JSON.parse($('variant-selects [data-selected-variant]').textContent);
    } catch (err) {
      return null;
    }
  };
  var priceText = function (sel) {
    var el = d.querySelector('#price-' + sec + ' ' + sel);
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  };

  // 5. Size must be chosen by the shopper
  var sizeSet = function () {
    return $('[data-ms-size]');
  };
  var chosen = !sizeSet() || !!sizeSet().querySelector('input:checked');
  var pending = function () {
    return !chosen && !!sizeSet();
  };
  function applyPending() {
    var fs = sizeSet();
    var p = pending();
    info.classList.toggle('ms-size-pending', p);
    if (!fs || !p) return;
    fs.querySelectorAll('input:checked').forEach(function (i) {
      i.checked = false;
    });
    var sel = fs.querySelector('[data-selected-value]');
    if (sel && !sel.querySelector('.ms-opt__choose')) sel.innerHTML = '<span class="ms-opt__choose">' + (info.dataset.msChooseText || 'choose your size') + '</span>';
  }
  var chooseText = sizeSet() && sizeSet().querySelector('.ms-opt__choose');
  if (chooseText) info.dataset.msChooseText = chooseText.textContent;
  function askSize() {
    var fs = sizeSet();
    if (!fs) return;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    fs.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    fs.classList.add('is-asking');
    var a = fs.querySelector('[data-ms-size-alert]');
    if (a) {
      a.textContent = '';
      setTimeout(function () {
        a.textContent = info.dataset.msAlert || 'Please choose a size';
      }, 60);
    }
    var first = fs.querySelector('input:not(.disabled)') || fs.querySelector('input');
    setTimeout(function () {
      (first || fs).focus({ preventScroll: true });
    }, reduce ? 0 : 350);
  }
  d.addEventListener(
    'change',
    function (e) {
      var fs = sizeSet();
      if (fs && fs.contains(e.target) && e.target.checked) {
        chosen = true;
        info.classList.remove('ms-size-pending');
        fs.classList.remove('is-asking');
        var a = fs.querySelector('[data-ms-size-alert]');
        if (a) a.textContent = '';
      }
    },
    true
  );
  d.addEventListener(
    'submit',
    function (e) {
      // getAttribute: the form has an input named "id", so form.id is that input
      if (pending() && e.target && e.target.getAttribute && e.target.getAttribute('id') === 'product-form-' + sec) {
        e.preventDefault();
        e.stopImmediatePropagation();
        askSize();
      }
    },
    true
  );
  d.addEventListener(
    'click',
    function (e) {
      if (pending() && e.target.closest && e.target.closest('.shopify-payment-button') && info.contains(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        askSize();
      }
    },
    true
  );

  // 6. Sibling links (length / pairs) open on the same size
  function famSync() {
    var v = variantJson();
    var fs = sizeSet();
    var sz = fs && !pending() ? fs.querySelector('input:checked') : null;
    d.querySelectorAll('[data-ms-vmap]').forEach(function (a) {
      var m, id;
      try {
        m = JSON.parse(a.getAttribute('data-ms-vmap'));
      } catch (err) {
        return;
      }
      if (sz) id = (v && m.t && m.t[v.title]) || (m.s && m.s[sz.value]);
      a.href = a.getAttribute('data-ms-url') + (id ? '?variant=' + id : '');
    });
  }

  // 3 + 4. Keep the button label and the sticky bar in step with the selected variant
  var sticky = d.querySelector('[data-ms-sticky]');
  function sync() {
    applyPending();
    famSync();
    var b = atc();
    var v = variantJson();
    var price = priceText('.ms-price__amount');
    var perEl = d.querySelector('#price-' + sec + ' [data-ms-per]');
    var per = perEl ? perEl.getAttribute('data-ms-per') : '';
    var available = !!(v && v.available);
    var waiting = pending();
    var choose = info.dataset.msChoose || 'Choose a size';
    if (b && available && !b.disabled) {
      var label = b.querySelector('span');
      var base = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
      if (label && waiting) label.textContent = choose;
      else if (label && info.hasAttribute('data-ms-atc-price') && price) label.textContent = base + ' · ' + price;
    }
    if (!sticky) return;
    var sv = sticky.querySelector('[data-ms-sticky-variant]');
    var sp = sticky.querySelector('[data-ms-sticky-price]');
    var spp = sticky.querySelector('[data-ms-sticky-per]');
    var sb = sticky.querySelector('[data-ms-sticky-btn]');
    if (sv && v && v.title) {
      var parts = v.title.split(' / ');
      if (waiting) {
        var vals = [].map.call(sizeSet().querySelectorAll('input'), function (i) {
          return i.value;
        });
        parts = parts.filter(function (x) {
          return vals.indexOf(x) < 0;
        });
        parts.push(choose.toLowerCase());
      }
      sv.textContent = parts.join(' · ');
    }
    if (sp && price) sp.textContent = price;
    if (spp) spp.textContent = per;
    if (sb) {
      sb.textContent = !available ? (window.variantStrings && window.variantStrings.soldOut) || 'Sold out' : waiting ? choose : sb.getAttribute('data-label');
      sb.setAttribute('aria-disabled', available ? 'false' : 'true');
    }
  }

  var preset = null; // the automatic "Most popular" selection must not move focus or scroll
  var touched = false;
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
    window.addEventListener(
      ev,
      function () {
        touched = true;
      },
      { once: true, passive: true }
    );
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      if (e && e.data && e.data.sectionId !== sec) return;
      var ns = e && e.data && e.data.html && e.data.html.getElementById('MsShip-' + sec);
      var os = d.getElementById('MsShip-' + sec);
      if (ns && os) os.outerHTML = ns.outerHTML;
      sync();
      if (preset) {
        var r = preset;
        preset = null;
        setTimeout(function () {
          var ae = d.activeElement;
          if (ae && ae.id === r.id) ae.blur(); // Dawn renames the old inputs' ids, so match the saved id
          if (!touched && window.scrollY !== r.y) window.scrollTo(0, r.y);
        }, 120);
      }
    });
  }

  if (sticky) {
    var showClass = sticky.hasAttribute('data-desktop') ? 'ms-has-sticky-desktop' : 'ms-has-sticky';
    var shown = null;
    var setShown = function (show) {
      if (show === shown) return;
      shown = show;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.inert = !show;
      d.body.classList.toggle('ms-has-sticky', show);
      d.body.classList.toggle(showClass, show);
      d.documentElement.style.scrollPaddingBottom = show ? sticky.offsetHeight + 16 + 'px' : '';
    };
    // A scroll check (not IntersectionObserver): jumps such as anchor links can skip
    // past the button without ever crossing it, and IO would then miss the change.
    var ticking = false;
    var check = function () {
      ticking = false;
      var b = atc();
      setShown(!!b && b.getBoundingClientRect().bottom < 0);
    };
    var queue = function () {
      if (!ticking) {
        ticking = true;
        setTimeout(check, 80);
      }
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    setShown(false);
    check();
    sticky.querySelector('[data-ms-sticky-btn]').addEventListener('click', function () {
      var b = atc();
      if (!b) return;
      if (pending()) return askSize();
      var v = variantJson();
      if (b.disabled || !(v && v.available)) {
        var picker = d.getElementById('variant-selects-' + sec) || b;
        picker.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        return;
      }
      b.click();
    });
  }

  // Dawn scrolls the window back up to the photo after every option change. On a phone
  // that throws the shopper away from the options and the button, so skip that one jump
  // when the change came from the picker (the gallery still switches to the new photo).
  var quietUntil = 0;
  d.addEventListener(
    'change',
    function (e) {
      if (e.target.closest && e.target.closest('variant-selects') && info.contains(e.target)) quietUntil = Date.now() + 5000;
    },
    true
  );
  function patchGallery() {
    var MG = customElements.get('media-gallery');
    if (!MG || MG.prototype.msQuiet) return;
    var orig = MG.prototype.setActiveMedia;
    MG.prototype.msQuiet = true;
    MG.prototype.setActiveMedia = function (id, prepend) {
      if (Date.now() > quietUntil) return orig.call(this, id, prepend);
      quietUntil = 0;
      var ws = window.scrollTo;
      window.scrollTo = function () {};
      try {
        orig.call(this, id, prepend);
      } finally {
        setTimeout(function () {
          window.scrollTo = ws;
        }, 60);
      }
    };
  }

  if (window.customElements && customElements.whenDefined) customElements.whenDefined('media-gallery').then(patchGallery);

  function start() {
    // 2. Start on the most popular pack (only when the link names no variant)
    var f = info.querySelector('[data-ms-preselect]');
    if (f && !/[?&](variant|option_values)=/.test(location.search)) {
      var input = d.getElementById(f.getAttribute('data-ms-preselect'));
      if (input && !input.checked) {
        preset = { id: input.id, y: window.scrollY };
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    sync();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})();
